import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

const TermsText = () => (
  <Row>
    <Col className='terms-text'>
      <h3>Introduction</h3>
      <p>
        These Terms and Conditions govern Your relationship with Us. They are
        important and You should review them. They include terms that You are
        agreeing to including, but not limited to, subscription renewal and
        automatic charges, arbitrating disputes in Illinois, on a non-class
        basis, and without a jury trial; acceptance of Our{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link>; terms governing
        marketing such as mobile messages, emails, cookies, and tracking; and
        other important terms.
      </p>
      <p>These Terms and Conditions were last updated May 15, 2025.</p>
      <h3>Interpretation and Definitions</h3>
      <h4>Interpretation</h4>
      <p>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions will
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>
      <h4>Definitions</h4>
      <p>For the purposes of these Terms and Conditions:</p>
      <p>
        <b>Affiliate</b> means an entity that controls, is controlled by or is
        under common control with a party, where “control” means ownership of
        50% or more of the shares, equity interest or other securities entitled
        to vote for election of directors or other managing authority.
      </p>
      <p>
        <b>Account</b> means a unique account created for You to access Our
        Service or parts of Our Service.
      </p>
      <p>
        <b>Country</b> refers to: Illinois, United States
      </p>
      <p>
        <b>Company</b> (called either “the Company”, “We”, “Us” or “Our” in
        these Terms and Conditions) refers to Bump Health, Inc., 7719 N Pioneer
        Lane, Peoria, Illinois 61615.
      </p>
      <p>
        <b>Device</b> means any device that can access the Service such as a
        computer, a cellphone or a digital tablet.
      </p>
      <p>
        <b>Feedback</b> means feedback, innovations or suggestions sent by You
        regarding the attributes, performance or features of Our Service.
      </p>
      <p>
        <b>Free</b> Trial refers to a limited period of time that may be free
        when purchasing a Subscription.
      </p>
      <p>
        <b>Goods</b> refer to the items offered for sale on the Service whether
        as individual items, as part of a package, or through a subscription.
      </p>
      <p>
        <b>Orders</b> mean a request by You to purchase Goods from Us.
      </p>
      <p>
        <b>Promotions</b> refer to contests, sweepstakes or other promotions
        offered through the Service.
      </p>
      <p>
        <b>Service</b> refers to the Website.
      </p>
      <p>
        <b>Terms</b> and Conditions (also referred as `Terms`) mean these Terms
        and Conditions that form the entire agreement between You and the
        Company regarding the use of the Service.
      </p>
      <p>
        <b>Third</b>-party Social Media Service means any services or content
        (including, but not limited to, data, information, products or services)
        provided by a third-party that may be displayed, included or made
        available by the Service.
      </p>
      <p>
        <b>Website</b> refers to Bump Boxes, accessible from
      </p>
      <p>
        You means the individual accessing or Using the Service, or the company,
        or other legal entity on behalf of which such individual is accessing or
        Using the Service, as applicable.
      </p>
      <h3>Acknowledgment</h3>
      <p>
        These are the Terms and Conditions governing the use of this Service and
        the agreement that operates between You and the Company. These Terms and
        Conditions set out the rights and obligations of all Users regarding the
        use of the Service.
      </p>
      <p>
        Your access to and use of the Service is conditioned on Your acceptance
        of and compliance with these Terms and Conditions. These Terms and
        Conditions apply to all visitors, Users and others who access or use the
        Service.
      </p>
      <p>
        By accessing or Using the Service You agree to be bound by these Terms
        and Conditions. If You disagree with any part of these Terms and
        Conditions then You may not access the Service.
      </p>
      <p>
        You represent that You are over the age of 18. The Company does not
        permit those under 18 to use the Service.
      </p>
      <p>
        Your access to and use of the Service is also conditioned on Your
        acceptance of and compliance with the of the Company. Our describes Our
        policies and procedures on the collection, use and disclosure of Your
        personal information when You Use the Application or the Website and
        tells You about Your privacy rights and how the law protects You. Please
        read Our carefully before using Our Service.
      </p>
      <h3>Placing Orders for Goods</h3>
      <p>
        By placing an Order for Goods through the Service, You warrant that You
        are legally capable of entering into binding contracts.
      </p>
      <h4>Your Information</h4>
      <p>
        To place an Order for Goods available on the Service, You may be asked
        to supply certain information relevant to Your Order including, without
        limitation, Your name, Your email, Your phone number, Your credit card
        number, the expiration date of Your credit card, Your billing address,
        and Your shipping information.
      </p>
      <p>
        You represent and warrant that: (i) You have the legal right to use any
        credit or debit card(s) or other payment method(s) in connection with
        any Order; and that (ii) the information You supply to Us is true,
        accurate, correct, and complete.
      </p>
      <p>
        By submitting such information, You grant Us the right to provide the
        information to payment processing third-parties for purposes of
        facilitating the completion of Your Order.
      </p>
      <h4>Order Cancellation</h4>
      <p>
        We reserve the right to refuse or cancel Your Order at any time for
        certain reasons including but not limited to:
      </p>
      <p>Goods availability</p>
      <p>Errors in the description or prices for Goods</p>
      <p>Errors in Your Order</p>
      <p>
        We reserve the right to refuse or cancel Your Order if fraud or an
        unauthorized or illegal transaction is suspected.
      </p>
      <h5>Your Order Cancellation Rights</h5>
      <p>
        Any Goods You purchase can only be returned in accordance with these
        Terms and Conditions and Our Returns Policy.
      </p>
      <p>
        Our Returns Policy forms a part of these Terms and Conditions. Please
        read Our Returns Policy to learn more about Your right to cancel Your
        Order. If You ordered Goods through a subscription, please read the
        Subscription for Goods and Autorenewals/Automatic Charges section of
        these Terms.
      </p>
      <p>
        Your right to cancel an Order only applies to Goods that are returned in
        the same condition as You received them. You should also include all of
        the product’s instructions, documents and wrappings. Goods that are
        damaged or not in the same condition as You received them or which are
        worn simply beyond opening the original packaging will not be refunded.
        You should therefore take reasonable care of the purchased Goods while
        they are in Your possession.
      </p>
      <p>
        We will reimburse You not later than 14 days from the day on which We
        receive the returned Goods. We will use the same means of payment as You
        used for the Order, and You will not incur any fees for such
        reimbursement.
      </p>
      <p>
        You will not have any right to cancel an Order for the supply of any of
        the following Goods:
      </p>
      <p>The supply of Goods made to Your specifications or personalized.</p>
      <p>
        The supply of Goods which according to their nature are not suitable to
        be returned, deteriorate rapidly or where the date of expiry is over.
      </p>
      <p>
        The supply of Goods which are not suitable for return due to health
        protection or hygiene reasons and were unsealed after delivery.
      </p>
      <p>
        The supply of Goods which are, after delivery, according to their
        nature, inseparably mixed with other items.
      </p>
      <p>Durable medical equipment.</p>
      <p>Goods secured through a subscription arrangement.</p>
      <p>
        The supply of digital content which is not supplied on a tangible medium
        if the performance has begun with Your prior express consent and You
        have acknowledged Your loss of cancellation right.
      </p>
      <h4>Availability, Errors and Inaccuracies</h4>
      <p>
        We are constantly updating Our offerings of Goods on the Service. The
        Goods available on Our Service may be mispriced, described inaccurately,
        or unavailable, and We may experience delays in updating information
        regarding Our Goods on the Service and in Our advertising on other
        websites.
      </p>
      <p>
        We cannot and do not guarantee the accuracy or completeness of any
        information, including prices, product images, specifications,
        availability, and services. We reserve the right to change or update
        information and to correct errors, inaccuracies, or omissions at any
        time without prior notice.
      </p>
      <h4>Prices Policy</h4>
      <p>
        The Company reserves the right to revise its prices at any time prior to
        accepting an Order.
      </p>
      <p>
        The prices quoted may be revised by the Company after accepting an Order
        in the event of any occurrence affecting delivery caused by government
        action, variation in customs duties, increased shipping charges, higher
        foreign exchange costs and any other matter beyond the control of the
        Company. In that event, You will have the right to cancel Your Order.
      </p>
      <h4>Payments</h4>
      <p>
        All Goods purchased are subject to a one-time payment. Payment may be
        made through various payment methods We have available, such as Visa,
        MasterCard, Affinity Card, American Express cards or online payment
        methods (PayPal, for example).
      </p>
      <p>
        Payment cards (credit cards or debit cards) are subject to validation
        checks and authorization by Your card issuer. If We do not receive the
        required authorization, We will not be liable for any delay or
        non-delivery of Your Order.
      </p>
      <h5>Third-Party Payment and Financing Providers</h5>
      <p>
        We may offer You the option to finance Your purchase through third-party
        payment providers. These providers operate independently from Us and are
        subject to their own terms, conditions, and privacy policies. By
        choosing to use such services, You agree to be bound by the applicable
        terms of the selected provider.
      </p>
      <p>
        Any financing terms, including interest, fees, payment schedules, credit
        checks, or other obligations, are solely between You and the third-party
        provider. We are not responsible for any decisions made by the provider
        regarding eligibility, payment approval, or account status, nor are We
        liable for any disputes arising from Your use of such services.
      </p>
      <p>
        We are not a lender or consumer debt financer. Any financing or payment
        plans offered through the Service are provided solely by independent
        third-party providers. We do not extend credit, assess creditworthiness,
        or make financing decisions. All questions about financing terms,
        obligations, or disputes should be directed to the applicable
        third-party provider.
      </p>
      <p>
        Please review the terms of the third-party provider carefully before
        selecting a financing option at checkout.
      </p>
      <h3>Shipping Protection</h3>
      <p>
        Shipping Protection is offered through InsureShield® Shipping Insurance,
        provided by UPS Capital Insurance Agency, Inc. Shipping Protection is
        not required for purchase and supplements existing implied and express
        warranties. Proof of loss may be required to make a claim. Please make
        all claims as soon as possible. Shipping protection is fully managed
        through a third-party company. All claims must be processed and made
        through UPS Capital Insurance Agency, Inc., its agents and
        representatives. Please visit
        https://www.insureshield.com/Us/en/claims.html to make a claim.
        Additional third-party terms and conditions apply.
      </p>
      <h3>Terms Applicable to Durable Medical Equipment</h3>
      <p>
        The following terms and conditions, along with Our other Terms, apply to
        Our customers who are interested in, request, order, or otherwise engage
        with Us as it relates to durable medical equipment such as, but not
        limited to, breast pumps. In this section, You may be called the
        patient, Patient, client, Client or You. Insofar as You are interested
        in, requesting, ordering, or otherwise engage with Us as it relates to
        durable medical equipment, such as breast pumps, these Terms will
        supersede any conflicting Terms and otherwise will supplement those
        Terms.
      </p>
      <h4>Authorization/Consent for Care/Service</h4>
      <p>
        The patient or representative ordering, You, has been informed of the
        home care treatment and product options available to You and of the
        selection of providers from which the patient, You, may choose. You
        further authorize Us under the direction of Your prescribing physician,
        to provide home medical equipment, supplies and services either directly
        or through Our affiliated companies. You acknowledge that the
        Client/Patient Service Agreement has been explained and that You
        understand the information.
      </p>
      <p>
        For Goods that are single use and which We may expect You to need sent
        to You over time, i.e. breast milk bags, You may have to confirm that
        You still need the Goods. You agree that We may send You a text message
        asking You to confirm whether You still need such Goods. You agree to
        respond truthfully whether You need the same. You further agree that
        should You not respond, then may not order or ship You such Goods.
      </p>
      <p>
        There are three appendixes at the end of these Terms that apply to You.
        You should read them.
      </p>
      <h4>Assignment of Benefits/Authorization for Payment</h4>
      <p>
        All benefits and payments musty be made directly to Us or Our designated
        affiliated companies furnished home medical equipment, products and
        services. We, or Our affiliated companies, will seek such benefits and
        payments on the patient`s behalf. As a courtesy, We, or Our affiliated
        companies, will bill Medicare/Medicaid or other federally funded sources
        and other payers and insurer(s) providing coverage, with a copy to Us.
        You are responsible for providing all necessary information and for
        making sure all certification and enrollment requirements are fulfilled.
        Any changes in insurance coverage must be reported to Us within 10 days
        of the change.
      </p>
      <h4>Release of Information</h4>
      <p>
        The patient or representative requests and authorizes Us, the
        prescribing physician, hospital, and any other holder of information
        relevant to service or equipment provided by Us, or Our affiliated
        companies, to release information upon request, to Us, Our affiliated
        companies, any payer source, physician, or any other medical personnel
        or agency involved with service. The patient also authorizes Us and Our
        affiliated companies to review medical history and payer information for
        the purpose of providing treatment, equipment or products.
      </p>
      <h4>Financial Responsibility, Arrangements, and Health Insurance</h4>
      <p>
        All payment and all sums that may become due for the services or
        products provided are due at the time services are rendered unless
        payment arrangements have been approved in advance by Our staff. These
        sums include, but are not limited to, all deductibles, co-payments,
        out-of-pocket requirements, and non-covered services. If for any reason
        and to any extent, We do not receive payment from the patient`s payer
        source because the patient is no longer eligible for coverage or because
        the service or product is not covered, the patient`s balance will be due
        in full, within 30 days of receipt of invoice. We cash, checks, &amp;
        most major credit cards. Payments by check may be converted into
        electronic fund transfers and funds may be debited from Your account as
        soon as the same day payment is received.
      </p>
      <p>
        All patient owed charges not paid within 30 days of billing date shall
        be assessed late charges and are subject to legally allowable interest
        charges. In such an event, the patient will be liable for all charges,
        including collection costs and all attorneys` fees, as applicable.
        Balances older than 90 days may be subject to other collection fees and
        interest charges of 1.5% per month. We realize that temporary financial
        problems may affect timely payment to Your account. If such problems do
        arise, We encourage You to contact Us promptly for assistance in the
        management of Your account.
      </p>
      <p>
        You understand if You have an unpaid balance to Us and do not make
        satisfactory payment arrangements, my account may be placed with an
        external collection agency.
      </p>
      <p>
        In order for Us or their designated external collection agency to
        service my account, and where not prohibited by applicable law, You
        agree that We and the designated external collection agency are
        authorized to (i) contact You by telephone at the telephone number(s)
        You are providing, including wireless telephone numbers, which could
        result in charges to You, (ii) contact You by sending text messages
        (message and data rates may apply) or emails, using any email address
        You provide and (iii) methods of contact may include using
        pre-recorded/artificial voice message and/or use of an automatic dialing
        device, as applicable. Furthermore, You consent the designated external
        collection agency to share personal contact and account related
        information with third-party vendors to communicate account related
        information via telephone, text, email, and mail notification.
      </p>
      <h4>Financial Responsibility for Non-Covered Items</h4>
      <p>
        By accepting these Terms, You agree that if Your insurance does not
        cover all items ordered, even if the item is one that the patient or the
        healthcare provider has good reason to think is necessary, We will not
        charge the insurance company and You will have financial responsibility
        for payment for the non-covered item(s).
      </p>
      <p>
        You also agree that We have offered alternative covered items (if any)
        and the cost of the non-covered item, and that You have then accepted
        financial responsibility for the non-covered item.
      </p>
      <h4>Intent, Previous Receipt of Breast Pump</h4>
      <p>
        By agreeing to these Terms, You are also attesting that You are
        pregnant, You desire to order a breast pump, and You have not already
        ordered or received an electric breast pump for this pregnancy.
      </p>
      <h4>Insurance Upgrade Breast Pumps</h4>
      <p>
        If You chose to order a breast pump designated as an `Insurance Upgrade
        Option` You have elected to order a breast pump that is not covered 100%
        by Your insurance. You will be required to pay the difference
        out-of-pocket. After Your insurance benefit has been applied You will be
        responsible for the out-of-pocket amount You authorized today at time of
        checkout. By checking the terms and conditions box You will be
        acknowledging that You had the option of selecting a breast pump 100%
        covered by Your insurance, but You chose the one that required an
        additional upcharge.
      </p>
      <h4>Returned Goods</h4>
      <p>
        Due to Federal and State Pharmacy Regulations ancillary items prescribed
        for home health care cannot be re-dispensed and cannot be returned for
        credit. Medical equipment cannot be returned. Sale items cannot be
        returned. All sales of durable medical equipment are final.
      </p>
      <h4>Consent for Contact &amp; Security of Information</h4>
      <p>
        By signing and submitting an order for durable medical equipment, You
        agree to and consent to receive phone calls, texts, emails, and
        pre-recorded messages from Us or any of Our subsidiaries regarding Our
        products and services, at the phone number(s) or email address provided;
        including wireless number if provided. These calls may be generated
        using an automated technology and normal carrier charges may apply. All
        Terms applicable to Our customers as it relates to SMS messaging apply
        to You, including, but not limited to, arbitration of any the terms
        applicable to Mobile Messaging as defined and explained below and the
        Disputes Resolution terms below.
      </p>
      <p>
        Most standard email is not a secure means of communication and Your
        protected health information that may be contained in Our emails to You
        will not be encrypted. This means that there is risk that Your protected
        health information in the emails could be intercepted and read by, or
        disclosed to, unauthorized third-parties. Similarly, mobile
        notifications regarding Your Order, text alerts will be sent to the
        number You provide. You understand that anyone with access to the mobile
        phone or carrier account associated with the number You have provided
        will be able to see this information.
      </p>
      <p>
        Use of alternative and more secure methods of communication with Us,
        such as telephone, fax or the U.S. Postal Service are available to You.
        If You do not wish to accept the risks associated with non-secure
        unencrypted email communications from Us containing Your protected
        health information, please indicate that You do not wish to receive such
        emails from Us by contacting Us at 888-913-7879. If You agree to receive
        information from Us via email or text, You agree to accept the security
        and privacy risks of this type of communication.
      </p>
      <p>
        By signing and submitting an order for durable medical equipment, You
        agree to and consent to receive patient surveys. We often send these via
        email approximately 5-7 days after Your Order has been shipped. Data
        collected/analyzed each week. By agreeing to Our Terms, You acknowledge
        that You have been informed of this patient satisfaction survey
        procedure.
      </p>
      <h4>Information for Medicare Patients</h4>
      <p>
        The products and/or services provided to the patient by Us are subject
        to the supplier standards contained in the federal regulations shown at
        42 Code of Federal Regulations § 424.57(c). These standards concern
        business professional and operational matters (e.g., honoring warranties
        and hours of operation).The full text of these standards can be obtained
        at{' '}
        <a href='https://www.ecfr.gov/' target='_blank' rel='noreferrer'>
          https://www.ecfr.gov/
        </a>
        . Upon request We will furnish You a written copy of the standards.
      </p>
      <h4>On-Call/After Hours Service</h4>
      <p>
        We maintain 24-hour availability through Our main telephone
        (866-418-8695). This on-call service is free to You. Should a
        life-threatening medical emergency arise, the patient or caregiver
        should contact their local emergency services number immediately for
        assistance (Usually 911).
      </p>
      <h4>Patient Complaint/Grievance Process</h4>
      <p>
        In the event You should become dissatisfied with any portion of Our
        provided home care experience, a complaint may be lodged with Us without
        concern for reprisal, discrimination, or unreasonable interruption of
        service. The patient has the right to present questions or grievances to
        one of Our staff members and to receive a response in a reasonable
        period of time. For concerns about quality of care or other services,
        please contact Our office by phone or mail. Grievances can also be
        reported to Medicare, or Bump Health Inc.`s Medicare accreditation
        agency, BOC or HQAA. All contact information and Our process for
        handling complaints can be found below.
      </p>
      <p>
        The following procedure details the steps that Bump Health Inc. will
        take when a Your complaint/grievance is received.
      </p>
      <p>
        After receiving the concern, the Our Customer Service Supervisor will
        take the following steps:
      </p>
      <p>
        Contact the person making the concern within a reasonable amount of
        time, attempting to do so within 5 days, if contact has not already been
        established.
      </p>
      <p>
        Determine what actions You feel should be initiated regarding the
        concern.
      </p>
      <p>
        Speak with involved employees and conduct additional training as
        appropriate.
      </p>
      <p>Attempt to resolve the concern to Your satisfaction.</p>
      <p>
        Report status of activities to You as soon as possible, aiming for
        within two business days following receipt of concern.
      </p>
      <p>
        Send complaint information to Our compliance staff so they can record
        it.
      </p>
      <p>
        If the complaint remains unresolved, We will have a department
        supervisor contact You as soon as possible, with the aim of doing so
        within five working days.
      </p>
      <p>
        Within a commercially reasonable amount of time, aiming for within 14
        days, We will provide written notification to You of the results of the
        investigation.
      </p>
      <p>
        Thereafter, Our standard dispute resolution terms shall apply. The
        appear in the Disputes Resolution section.
      </p>
      <h3>Subscription for Goods and Autorenewals/Automatic Charges</h3>
      <p>
        We offer much of Our products on a repeated shipping basis. Our Bump
        Boxes® ship monthly. You must understand that certain ordering methods
        may result in automatic renewals or automatic charges to a payment
        method You provided Us.
      </p>
      <h5>Month-to-Month Subscriptions</h5>
      <p>
        With a subscription, We will automatically ship Goods in one of Our
        boxes, i.e. a BUMP BOX® or BITSY BOX™, each month until You cancel Your
        subscription. You will be immediately charged for the first month of
        Your subscription. This may or may not be a lower, promotional rate.
        Thereafter, You will be automatically charged on or about the same day
        of the month for each shipment at the regular rate until You cancel Your
        subscription. The exact date of charge might vary based on the days of
        the month, i.e. February only—usually—has 28 days.
      </p>
      <p>
        The Company, in its sole discretion and at any time, may modify the
        amounts it charges for each box. The Company will provide You with
        reasonable prior notice, at least 30 days in advance of any change in
        subscription fees to give You an opportunity to terminate Your
        subscription before such change becomes effective. You consent to such
        notification by email or text message to the contact information You
        provided to Us when You began Your subscription. Your failure to cancel
        Your subscription after a notice offer change comes into effect
        constitutes Your agreement to pay the modified subscription fee amount.
      </p>
      <h5>Term Subscription</h5>
      <p>
        We may offer You a subscription where you make a binding commitment to a
        set number of months for the subscription: a three-, six-, nine-, or
        twelve-month subscription. (the “Initial Term” in this Term Subscription
        section). With a subscription, We will automatically ship Goods in one
        of Our boxes, i.e. a BUMP BOX® or BITSY BOX™, each month until You
        cancel Your subscription. After your Initial Term, your subscription
        will be converted to a Month-to-Month subscription, whose terms appear
        above. You acknowledge and agree that You are entering into an agreement
        with Us to maintain a subscription for at least the Initial Term’s
        length and that We have provided you with consideration, such as, but
        not limited to, free gifts, lower initial month’s cost, or ongoing lower
        monthly cost, in exchange for your time commitment. Your minimum
        purchase obligation is the sum of each monthly payment included in your
        Initial Term.
      </p>
      <p>
        When you select a term subscription, You will be immediately charged for
        the first month of Your subscription. This may or may not be a lower,
        promotional rate. Thereafter, You will be automatically charged on or
        about the same day of the month for each shipment at the regular rate
        until You cancel Your subscription. The exact date of charge might vary
        based on the days of the month, i.e. February only—usually—has 28 days.
      </p>
      <p>
        You may, without penalty or fee, cancel at any time after You have
        fulfilled the Initial Term, i.e. paid for six, nine, or twelve months
        and fulfilled your minimum purchase obligation. That said, if you wish
        to cancel before the expiration of the term you agreed to, then you may
        be required to pay a cancellation fee. Again, you acknowledge that you
        were offered incentives such as, but not limited to, free gifts, lower
        initial month’s cost, or ongoing lower monthly cost, in exchange for
        your commitment to a set amount of time for the subscription.
      </p>
      <h5>Cancelling Subscriptions</h5>
      <p>
        You may cancel Your subscription renewal either through Your Account
        settings page or by contacting the Company. You will not receive a
        refund for any subscription fees paid unless the law mandates a refund.
        For subscriptions under the Month-to-Month terms above (whether
        initially selected or because a Term Subscription converted to such),
        You must cancel before the next billing date to avoid additional charges
      </p>
      <h5>Prepaid Package</h5>
      <p>
        We may offer a package for a set number of months’ boxes shipped and You
        prepay the full amount at the time of ordering. If You purchase this
        package, then We will charge You, a single-time, for the amount listed.
        Then We will ship the requisite number of boxes on a monthly basis and
        when all boxes in the package have shipped, then shipments will cease.
      </p>
      <h4>Billing</h4>
      <p>
        You shall provide the Company with accurate and complete billing
        information including full name, address, state, zip code, telephone
        number, and a valid payment method information.
      </p>
      <p>
        Should automatic billing fail to occur for any reason, then Your Goods
        may not ship. And We may issue You an electronic invoice indicating that
        You must proceed manually, within a certain deadline date, with the full
        payment corresponding to the billing period as indicated on the invoice.
      </p>
      <h4>Refunds</h4>
      <p>Refunds will be considered case-by-case basis.</p>
      <h4>Free or Promotional Trials</h4>
      <p>
        We may, at Our sole discretion, offer a subscription or package with a
        lower initial month (or even free month) or free gift—a “Promotional
        Trial.” You may be required to enter Your billing information in order
        to sign up for the Promotional Trial. You will be charged as provided
        for during the checkout process for future shipments or subscription
        fees.
      </p>
      <p>
        A Promotional Trial may require You provide Your billing information to
        sign up for Goods or services for free for a limited amount of time—a
        “Free Trial.” If You do enter Your billing information when signing up
        for a Free Trial, You will not be charged by the Company until the Free
        Trial has expired. On the last day of the Free Trial period, unless You
        cancelled Your subscription, sou will be automatically charged the
        applicable subscription fee or package payment for the subscription or
        package have selected.
      </p>
      <p>
        At any time and without notice, the Company reserves the right to (i)
        modify the terms and conditions of a Promotional Trial offer, or (ii)
        cancel such Promotional Trial offer.
      </p>
      <h3>Promotions</h3>
      <p>
        Any Promotions made available through the Service may be governed by
        rules that are separate from these Terms. If You participate in any
        Promotions, please review the applicable rules as well as Our{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link>. If the rules for a
        promotion conflict with these Terms, the Promotion rules will apply.
      </p>
      <h3>User Accounts</h3>
      <p>
        When You create an account with Us, You must provide Us information that
        is accurate, complete, and current at all times. Failure to do so
        constitutes a breach of the Terms, which may result in immediate
        termination of Your account on Our Service.
      </p>
      <p>
        You are responsible for safeguarding the password that You Use to access
        the Service and for any activities or actions under Your password,
        whether Your password is with Our Service or a Third-Party Social Media
        Service.
      </p>
      <p>
        You agree not to disclose Your password to any third-party. You must
        notify Us immediately upon becoming aware of any breach of security or
        unauthorized use of Your Account.
      </p>
      <p>
        You may not use as a Username the name of another person or entity or
        that is not lawfully available for use, a name or trademark that is
        subject to any rights of another person or entity other than You without
        appropriate authorization, or a name that is otherwise offensive, vulgar
        or obscene.
      </p>
      <h3>Indemnification</h3>
      <p>
        You agree to indemnify, defend, and hold Us harmless from and against
        any and all claims, liabilities, damages, losses, costs, and expenses
        (including reasonable attorneys&lsquo; fees) arising out of or related
        to: (a) any false, inaccurate, or misleading information You provide to
        Us; (b) Your use or misuse of the Service or any Goods ordered through
        the Service; or (c) Your violation of these Terms or any applicable law
        or regulation. This obligation survives termination of Your use of the
        Service.
      </p>
      <p>
        This indemnification is in addition to, and not in substitution of, any
        indemnification obligations You undertake as part of Your participation
        in Our Mobile Services and email marketing.
      </p>
      <h3>Intellectual Property</h3>
      <p>
        The Service and its original content (excluding content provided by You
        or other Users), features and functionality are and will remain the
        exclusive property of the Company and its licensors.
      </p>
      <p>
        The Service is protected by copyright, trademark, and other laws of both
        the Country and foreign countries.
      </p>
      <p>
        Our trademarks and trade dress may not be used in connection with any
        product or service without the prior written consent of the Company.
      </p>
      <h4>Your Feedback to Us</h4>
      <p>
        You assign all rights, title and interest in any Feedback You provide
        the Company. If for any reason such assignment is ineffective, You agree
        to grant the Company a non-exclusive, perpetual, irrevocable, royalty
        free, worldwide right and license to use, reproduce, disclose,
        sub-license, distribute, modify and exploit such Feedback without
        restriction.
      </p>
      <h4>Digital Millennium Copyright Act &amp; Intellectual Property</h4>
      <p>We respect others’ intellectual property rights.</p>
      <p>
        If You believe that your copyrighted work has been copied in a way that
        constitutes infringement and is accessible by the Service, please notify
        Our copyright agent, as set forth in the Digital Millennium Copyright
        Act of 1998 (“DMCA”). For your complaint to be valid under the DMCA, you
        must provide the following information in writing:
      </p>
      <p>
        An electronic or physical signature of a person authorized to act on
        behalf of the copyright owner.
      </p>
      <p>Identification of the copyrighted work you claim is infringed.</p>
      <p>
        Identification of the material you claim is infringing and where it is
        located on the Service.
      </p>
      <p>
        Information reasonably sufficient to permit Us to contact you, such as
        an address, telephone number, and email address.
      </p>
      <p>
        A statement you have a good-faith belief that use of the material in the
        manner complained of is not authorized by the copyright owner, its
        agent, or law.
      </p>
      <p>
        A statement, made under penalty of perjury, that the above information
        is accurate, and that you are the copyright owner or are authorized to
        act on behalf of the owner.
      </p>
      <p>You must submit this information to the following DMCA agent:</p>
      <p>
        DMCA Agent Bump Health, Inc. c/o Jonathan LA Phillips Phillips &amp;
        Bathke, P.C. 300 Northeast Perry Peoria, Illinois 61616 Email:
        jlap@pb-iplaw.com
      </p>
      <p>
        If your submission is removed as a result of a DMCA notice, You may
        provide us with a DMCA counter-notice. To do so, you must include the
        following information:
      </p>
      <p>Your name, address, telephone number, and email address (if any).</p>
      <p>
        A description of the material that was removed and its location where it
        previously appeared.
      </p>
      <p>
        A statement under penalty of perjury that you have a good-faith belief
        the material was removed or disabled as a result of mistake or
        misidentification.
      </p>
      <p>
        A statement you consent to the jurisdiction of the United States
        District Court in which your address is located or, if your address is
        outside the United States, any jurisdiction in which you may be properly
        served, and that you will accept service of process from the person who
        filed the original DMCA notice or an agent of that person.
      </p>
      <p>Your electronic signature.</p>
      <p>
        If you believe some other intellectual property right you have an
        interest in is infringed, you may notify us at:
      </p>
      <p>
        IP Infringement Bump Health, Inc. c/o Jonathan LA Phillips Phillips
        &amp; Bathke, P.C. 300 Northeast Perry Peoria, Illinois 61616 Email:
        jlap@pb-iplaw.com
      </p>
      <h3>Links to Other Websites</h3>
      <p>
        Our Service may contain links to third-party web sites or services that
        are not owned or controlled by the Company.
      </p>
      <p>
        The Company has no control over, and assumes no responsibility for, the
        content, privacy policies, or practices of any third-party web sites or
        services. You further acknowledge and agree that the Company shall not
        be responsible or liable, directly or indirectly, for any damage or loss
        caused or alleged to be caused by or in connection with the use of or
        reliance on any such content, goods or services available on or through
        any such web sites or services.
      </p>
      <p>
        We strongly advise You to read the terms and conditions and privacy
        policies of any third-party web sites or services that You visit.
      </p>
      <h3>Termination</h3>
      <p>
        We may terminate or suspend Your Account immediately, without prior
        notice or liability, for any reason whatsoever, including, without
        limitation, if You breach these Terms and Conditions.
      </p>
      <p>
        Upon termination, Your right to use the Service will cease immediately.
        If You wish to terminate Your Account, email us at info@bumpboxes.com.
      </p>
      <h3>Limitation of Liability</h3>
      <p>
        Notwithstanding any damages that You might incur, the entire liability
        of the Company and any of its suppliers under any provision of this
        Terms and Your exclusive remedy for all of the foregoing shall be
        limited to the amount actually paid by You through the Service or 100
        USD if You have not purchased anything through the Service.
      </p>
      <p>
        To the maximum extent permitted by applicable law, in no event shall the
        Company or its suppliers be liable for any special, incidental,
        indirect, or consequential damages whatsoever (including, but not
        limited to, damages for loss of profits, loss of data or other
        information, for business interruption, for personal injury, loss of
        privacy arising out of or related to or in any way related to the use of
        or inability to use the Service, third-party software and/or third-party
        hardware used with the Service, or otherwise in connection with any
        provision of this Terms), even if the Company or any supplier has been
        advised of the possibility of such damages and even if the remedy fails
        of its essential purpose.
      </p>
      <p>
        Some states do not allow the exclusion of implied warranties or
        limitation of liability for incidental or consequential damages, which
        means that some of the above limitations may not apply. In these states,
        each party&lsquo;s liability will be limited to the greatest extent
        permitted by law.
      </p>
      <h3>&ldquo;AS IS&rdquo; and “AS AVAILABLE” Disclaimer</h3>
      <p>
        The Service is provided to You “AS IS” and “AS AVAILABLE” and with all
        faults and defects without warranty of any kind. To the maximum extent
        permitted under applicable law, the Company, on its own behalf and on
        behalf of its affiliates and its and their respective licensors and
        service providers, expressly disclaims all warranties, whether express,
        implied, statutory or otherwise, with respect to the Service, including
        all implied warranties of merchantability, fitness for a particular
        purpose, title and non-infringement, and warranties that may arise out
        of course of dealing, course of performance, Usage or trade practice.
        Without limitation to the foregoing, the Company provides no warranty or
        undertaking, and makes no representation of any kind that the Service
        will meet Your requirements, achieve any intended results, be compatible
        or work with any other software, applications, systems or services,
        operate without interruption, meet any performance or reliability
        standards or be error free or that any errors or defects can or will be
        corrected.
      </p>
      <p>
        Without limiting the foregoing, neither the Company nor any of the
        Company’s provider makes any representation or warranty of any kind,
        express or implied: (i) as to the operation or availability of the
        Service, or the information, content, and materials or products included
        thereon; (ii) that the Service will be uninterrupted or error free;
        (iii) as to the accuracy, reliability, or currency of any information or
        content provided through the Service; or (iv) that the Service, its
        servers, the content, or emails sent from or on behalf of the Company
        are free from viruses, scripts, trojan horses, worms, malware, timebombs
        or other harmful components.
      </p>
      <p>
        Some jurisdictions do not allow the exclusion of certain types of
        warranties or limitations on applicable statutory rights of a consumer,
        so some or all the above exclusions and limitations may not apply to
        You. But in such a case the exclusions and limitations set forth in this
        section shall be applied to the greatest extent enforceable under
        applicable law.
      </p>
      <h3>Medical Disclaimer</h3>
      <p>
        This Website contains general information about conception, pregnancy,
        pregnancy products and parenting. The information is not complete or
        comprehensive. You should not rely on the information on this Website as
        an alternative to medical advice from your doctor or healthcare
        provider. Nothing contained on this Website should be construed nor is
        intended to be used for medical diagnosis or treatment. It should not be
        used in place of the advice of your physician or other qualified
        healthcare provider. Should you have any healthcare related questions,
        please call or see your physician or other qualified healthcare provider
        promptly.
      </p>
      <p>
        Always consult your physician or other qualified healthcare provider
        before embarking on a new treatment, diet or fitness program. If you
        have any specific questions about these matters you should consult your
        doctor or other healthcare provider. If you think you may be pregnant
        you should speak to a doctor or other healthcare provider, and if you
        think you may be suffering from any other medical condition you should
        seek immediate medical attention.
      </p>
      <p>
        You should never delay seeking medical advice, disregard medical advice,
        or discontinue medical treatment because of information on this Website.
        You are encouraged to consult your physician or your local healthcare
        provider to obtain professional medical advice, which may agree or
        disagree with the information and materials contained on this site. You
        should consult your own physician or your local healthcare provider
        regarding your own symptoms, medical condition, treatment or
        medications. If you have or suspect that you have a medical problem, you
        should contact your own physician or local healthcare provider
        immediately.
      </p>
      <p>
        While the information published on this site is believed to be accurate,
        it has been published solely for the purpose of provide general
        information and is not intended as a substitute for professional medical
        advice. If you have questions or concerns about your physical health or
        the health of your baby, please seek assistance from a qualified
        healthcare provider. The articles on this site are meant to answer
        questions of a general nature regarding issues of interest surrounding
        pregnancy. If you have a specific medical concern, please contact your
        healthcare provider.
      </p>
      <p>
        Call Your Doctor or Emergency Services in Case of Emergency. If you
        think you may have a medical emergency, call immediately. DO NOT USE
        THIS WEBSITE FOR MEDICAL EMERGENCIES.
      </p>
      <p>
        By using the Service, you understand and accept We are not a doctor,
        medical professional, licensed nutritionist, or registered dietician.
        You understand and accept statements within the Services have not been
        evaluated by the Food and Drug Administration. No products or
        information are intended to diagnose, treat, cure or prevent any
        disease.
      </p>
      <p>
        The information about the use of herbs and essential oils contained in
        this site is not meant to be a substitute for seeking the advice of a
        qualified health care provider. It is not intended to diagnose, treat,
        cure or prevent any disease. Always consult your health care provider
        about the use of herbs and essential oils, especially during pregnancy,
        when nursing a baby or with children. All images, text, design and
        layouts are copyright protected under the Federal Copyright Law and are
        the sole property of Bump Boxes, Inc. No form of reproduction of these
        images and photographs, including downloading, copying or saving of
        digital image files is authorized without the express written consent of
        Bump Boxes, Inc.
      </p>
      <h3>Consents Regarding Mobile Services, Marketing, and Tracking</h3>
      <h4>Mobile Messaging Marketing and Technology</h4>
      <p>
        We offer Our customers marketing and promotional mobile alerts
        (including cart reminders) by mobile message (the “Mobile Service“) on
        63846. By participating, You agree to the Terms and Our{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link>. You agree to
        participate by providing us your phone number in any field that
        indicates you will receive mobile messages from us upon doing so. These
        may be in the form of MMS, SMS, or RCS messages.
      </p>
      <p>
        Without limiting the scope of the Mobile Service, Users that opt into
        the Mobile Service can expect to receive messages concerning the
        marketing and sale of digital and physical products, services, and
        events. Your election to not opt-in to the Mobile Service will not
        prevent You from asking for and receiving any financial incentives
        provided through the Mobile Service.
      </p>
      <h5>Signing Up and Opting-In to the Service</h5>
      <p>
        Enrollment in the Mobile Service requires You to provide Your mobile
        phone number and to agree to these Terms. You may not enroll if You are
        under 18 years old. We reserve the right to stop offering the Mobile
        Service at any time with or without notice. We also reserve the right to
        change the short code or phone number from which messages are sent and
        We will notify You when We do so.
      </p>
      <p>By opting into the Mobile Service, You:</p>
      <p>
        Authorize and allow Us to use an automatic telephone dialing system to
        send recurring automated text messages to the mobile phone number
        associated with Your opt-in (i.e., the number listed on the opt-in form
        or, if none, the number from which You send the opt-in, or, if none, the
        number on file for the account associated with Your opt-in).
      </p>
      <p>
        Acknowledge that You do not have to agree to receive messages as a
        condition of purchase.
      </p>
      <p>
        Confirm that You are the subscriber to the relevant phone number or that
        You are the customary User of that number on a family or business plan
        and that You are authorized to opt-in.
      </p>
      <p>
        Agree to receive any notice, request, or message from Us through SMS
        (text) messaging, including those notifying You of renewal of
        subscriptions.
      </p>
      <p>
        Consent to the use of an electronic record to document Your opt-in. To
        request a free paper or email copy of the opt-in or to update Our
        records with Your contact information, contact info@BumpBoxes.com. To
        view and retain an electronic copy of these Terms or the rest of Your
        opt-in, You will need (i) a device (such as a computer or mobile phone)
        with Internet access, and (ii) and either a printer or storage space on
        such device. For an email copy, You will also need an email account You
        can access from the device, along with a browser or other software that
        can display the emails.
      </p>
      <h5>The Number You Provide for the Mobile Service</h5>
      <p>
        When You provide Us with a phone number for the Mobile Service, You are
        warranting that You are the subscriber to the relevant phone number or
        that You are the customary User of that number on a family or business
        plan and that You are authorized to opt-in.
      </p>
      <p>
        You agree and understand that We may use the area code of Your phone
        number to determine where We believe You are physically located and that
        any such assumptions based on the area code are fair and reasonable as
        it relates to determining the time We send You messages under the Mobile
        Service and otherwise. Even so, We may use other information We learn
        about You to make such a determination, and You agree that other
        information You provide Us, like Your billing or shipping address, the
        geolocation of Your IP address, and otherwise are also fair and
        reasonable means of determining Your physical location. Should You not
        agree to Our means of determining Your physical location, then You must
        email Us at info@bumpboxes.com to provide Your physical location.
      </p>
      <h5>Duty to Notify and Indemnification</h5>
      <p>
        If at any time You intend to stop using the telephone number that has
        been used to subscribe to the Mobile Service, including canceling Your
        service plan or selling or transferring the phone number to another
        party, You agree that You will complete the User Opt Out process set
        forth above before ending Your use of the mobile telephone number. If
        you cannot do so, email Us at info@bumpboxes.com to advise Us to remove
        the number from the Mobile Service.
      </p>
      <p>
        You understand and agree that your agreement to do so is a material part
        of these Terms. You further agree that, if You discontinue the use of
        Your mobile telephone number without notifying us of such change, You
        agree that You will be responsible for all costs (including attorneys’
        fees) and liabilities incurred by Us, or any party that assists Us in
        the Mobile Program, as a result of claims brought by individual(s) who
        are later assigned that mobile telephone number. This duty and agreement
        survive any cancellation or termination of Your agreement to participate
        in our Services, including the Mobile Service.
      </p>
      <p>
        AMONG OTHER DUTIES AS SET FORTH IN THE TERMS AND CONDITIONS AND THE{' '}
        <Link to='/privacy-policy'>PRIVACY POLICY</Link>, YOU AGREE THAT YOU
        SHALL INDEMNIFY, DEFEND, AND HOLD US HARMLESS FROM ANY CLAIM OR
        LIABILITY RESULTING FROM YOUR FAILURE TO NOTIFY US OF A CHANGE IN THE
        INFORMATION YOU HAVE PROVIDED, INCLUDING ANY CLAIM OR LIABILITY UNDER
        THE TELEPHONE CONSUMER PROTECTION ACT, 47 U.S.C. § 227, et seq., OR
        SIMILAR STATE AND FEDERAL LAWS, AND ANY REGULATIONS PROMULGATED
        THEREUNDER RESULTING FROM US ATTEMPTING TO CONTACT YOU AT THE TELEPHONE
        NUMBER YOU PROVIDED.
      </p>
      <p>
        Nothing under the heading “Duty to Notify and Indemnification” restricts
        or limits your duties to indemnify us or restricts Our limits Our rights
        under the Terms or <Link to='/privacy-policy'>Privacy Policy</Link>.
      </p>
      <h5>Content You May Receive</h5>
      <p>
        Once You affirm Your choice to opt-in to the Mobile Service on 63846,
        Your message frequency may vary based on Your interactions and initiated
        texts. You may receive alerts about:
      </p>
      <p>Sale promotions</p>
      <p>Event information</p>
      <p>Product launch announcements</p>
      <p>Cart reminders</p>
      <p>Back in stock alerts</p>
      <p>Price drop alerts</p>
      <p>Low inventory alerts</p>
      <p>and other information and marketing material We may provide.</p>
      <h5>Charges and Carriers</h5>
      <p>
        Message and data rates may apply. Please consult Your service agreement
        with Your wireless carrier or contact Your wireless carrier to determine
        Your phone’s pricing plan and the charges for sending and receiving text
        messages. You acknowledge that You are responsible for any message, data
        or other charges incurred (Usage, subscription, etc.) as a result of
        using the Mobile Service.
      </p>
      <p>
        Supported carriers are AT&amp;T, T-Mobile, Verizon Wireless, Sprint,
        Boost, Virgin Mobile, U.S. Cellular, Cricket, Alltel, Cincinnati Bell,
        Cellcom, C-Spire, nTelos, MetroPCS, and other smaller regional carriers.
        The Mobile Service may not be available on all wireless carriers. We may
        add or remove any wireless carrier from the Mobile Service at any time
        without notice. Neither We nor the wireless carriers are responsible for
        any undue delays, failure of delivery, or errors in messages.
      </p>
      <h5>To Stop the Mobile Service</h5>
      <p>
        To stop receiving text messages from Us, text the word STOP to 63846 any
        time or reply STOP to any of the text messages You have received from
        Us. This is the exclusive method for opting out. After texting STOP to
        63846, You will receive one additional message confirming that Your
        request has been processed.
      </p>
      <p>
        No further messages will be sent to Your mobile device, unless initiated
        by You. If You have subscribed to other mobile message programs operated
        by Us and wish to cancel, unless applicable law requires otherwise, You
        will need to opt out separately from those programs by following the
        instructions provided in their respective mobile terms. For Service
        support or assistance, text HELP to 63846 or email info@bumpboxes.com
        with copy to jlap@iplaw.com.
      </p>
      <p>
        You acknowledge that any messages, including any STOP or HELP requests,
        you send to a short code or telephone number We have changed may not be
        received and We will not be responsible for honoring requests made in
        such messages.
      </p>
      <h5>Non-liability for Mobile Service</h5>
      <p>
        To the extent permitted by applicable law, and without limiting the “AS
        IS” and “AS AVAILABLE” Disclaimer section, above, You agree that We will
        not be liable for failed, delayed, untimely—in any fashion or for any
        reason, or misdirected delivery of any information sent through the
        Mobile Service, any errors in such information, and/or any action You
        may or may not take in reliance on the information or Mobile Service.
      </p>
      <h5>Questions</h5>
      <p>
        You can text HELP for help at any time to 63846. This will provide You
        with Our customer service email address at info@BumpBoxes.com.
      </p>
      <h5>Changes to Terms</h5>
      <p>
        Terms applicable to the Mobile Service are subject to change at any time
        without notice.
      </p>
      <h4>Tracking Technologies</h4>
      <p>
        We use certain technologies for tracking, marketing, and remarketing
        purposes. It is incumbent upon You to review Our{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link>. You agree to that{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link> when You agree to Our
        Terms. That said, We wish to bring a few things to Your attention here
        as well which supplement without replacing Our{' '}
        <Link to='/privacy-policy'>Privacy Policy</Link> .
      </p>
      <p>
        We use technology provided by third-parties, such as, but not limited
        to, Meta and others to gather information about you, share that
        information for marketing, remarketing, and advertising targeting
        purposes. This can include Meta Pixel, AppLovin, Klaviyo, Google
        Analytics, Google Ads, TikTok Ads Manager, chat bots, what some might
        argue to be a “pen register,” and cookies, among other technologies. By
        agreeing to the Terms, You consent and agree to Our Use of technologies
        to track Your actions on Our Service, Your Orders, and collect
        information about You. Further, You consent and agree to Our sharing of
        that information with third-parties and Our receipt of similar
        information about You from third-parties.
      </p>
      <p>
        Without limiting Your general consent and agreement above, You, in
        particular, consent and agree to Our Use of Meta Pixel and similar
        technologies which collect information about You and shares it with Meta
        or other third-parties. We may share other information with Meta and
        third-parties. Meta and those third-parties may share it with more
        third-parties. And those third-parties and Meta may share information
        about You with Us. Some allege this amounts to “wiretapping.” While We
        disagree with such sentiment, it is important that You understand that
        We are sharing information and that You are agreeing and consenting to
        that when You agree to the Terms.
      </p>
      <p>
        Further, when You agree to the Terms, You agree and consent to the use
        of such technology. As a result, You are waiving legal claims to the
        extent that they can be waived, including, but not limited to, of
        violation of the California Invasion of Privacy Act—whether or not based
        on the premise that such technology functions as a pen register, the
        Video Privacy Protection Act, and similar claims that are rendered
        non-viable by your consent to these Terms.
      </p>
      <p>
        Additionally, as describe in the Disputes Resolution section below, by
        agreeing to the Terms, You are agreeing to arbitrate all disputes on an
        individual—not class—basis and are waiving the right to a jury trial.
      </p>
      <p>
        Again, review Our <Link to='/privacy-policy'>Privacy Policy</Link> ,
        which You agree to when agreeing to Our Terms.
      </p>
      <h3>Disputes Resolution</h3>
      <p>
        These dispute resolution Terms are part of the legal agreement between
        You and Us. They are deemed to be “a written agreement to arbitrate”
        under the Federal Arbitration Act. You and We agree that this section
        satisfies the “writing” requirement of the Federal Arbitration Act.
      </p>
      <p>
        PLEASE READ THESE DISPUTE RESOLUTION TERMS CAREFULLY. THEY CONTAIN
        PROVISIONS THAT LIMIT YOUR LEGAL RIGHTS, INCLUDING AN ARBITRATION
        PROVISION, WAIVERS OF CLASS ACTIONS AND JURY TRIALS, AND LIMITATIONS ON
        OUR LIABILITY. YOUR USE OF THE SERVICE OR Our OFFERINGS CONFIRMS YOUR
        UNCONDITIONAL ACCEPTANCE OF THESE DISPUTE RESOLUTION TERMS. IF YOU DO
        NOT ACCEPT THESE DISPUTE RESOLUTION TERMS AND ALL POLICIES, TERMS, AND
        CONDITIONS STATED OR INCORPORATED BY REFERENCE IN THESE DISPUTE
        RESOLUTION TERMS, YOU ARE PROHIBITED FROM, AND MUST IMMEDIATELY CEASE,
        ACCESSING OR USING THE SERVICE, THE MOBILE SERVICE, AND MAKING ANY
        ORDERS.
      </p>
      <h4>
        Non-applicability to Actions By Us to Enjoin Intellectual Property
        Violations
      </h4>
      <p>
        These Dispute Resolution Terms do not apply to any action by Us to
        resolve claims of intellectual property, i.e. copyright, trademark,
        patent, or trade secret, infringement or misappropriation. We may bring
        such claims in any court or administrative body having jurisdiction of
        the same.
      </p>
      <h4>You Must Try Informal Resolution First</h4>
      <p>
        If You have any concern or dispute with Us for any reason or any ground,
        You agree to first try to resolve the dispute informally by contacting
        Us at the contact information below. You agree to provide Us with
        fourteen days to attempt to resolve the dispute to Your satisfaction. By
        agreeing to these Terms, You agree that no further action can be taken
        without such effort. Thereafter, if You still have a dispute, then
      </p>
      <h4>Mandatory Arbitration of Disputes</h4>
      <p>
        If informal attempts at resolution are unsuccessful, then You agree to
        arbitrate all disputes with Us, regardless of the grounds for such a
        dispute.
      </p>
      <p>
        YOU AND WE AGREE THAT ANY CLAIM OR DISPUTE AT LAW OR EQUITY THAT HAS
        ARISEN OR MAY ARISE BETWEEN Us FOR ANY REASON, INCLUDING, BUT NOT
        LIMITED TO, USE OF THE SERVICE, PARTICIPATION IN THE MOBILE SERVICE,
        YOUR PURCHASE OF GOODS OR SERVICES FROM US, OR OTHERWISE WILL BE
        RESOLVED IN ACCORDANCE WITH THE PROVISIONS SET FORTH IN THIS SECTION.
        You and We agree that any and all disputes or claims that have arisen or
        may arise between You and Us shall be resolved exclusively through
        confidential, final, and binding arbitration on an individual basis;
        provided that either party may file suit in court seeking to enjoin
        infringement, misappropriation, or misuse of its intellectual property
        rights. YOU ARE GIVING UP THE RIGHT TO LITIGATE A DISPUTE IN COURT
        BEFORE A JUDGE OR JURY. YOU ARE GIVING UP THE RIGHT TO PARTICIPATE IN A
        CLASS ACTION OR CLASS-BASED ARBITRATION.
      </p>
      <p>
        THIS AGREEMENT DOES NOT ALLOW FOR CLASS ARBITRATIONS EVEN IF THE
        PROCEDURES OR RULES OF THE AAA WOULD. RATHER, YOU AND WE ARE ONLY
        ENTITLED TO PURSUE ARBITRATION ON AN INDIVIDUAL, BILATERAL BASIS. AND
        NOT AS PLAINTIFFS OR CLASS MEMBERS IN ANY PURPORTED CLASS OR
        REPRESNTATIVE PROVEEDINGS OR IN THE CAPACITY OF A PRIVATE ATTORNY
        GENERAL. FURTHER, AND UNLESS YOU AND BUMP HEALTH, INC. AGREE OTHERWISE
        IN WRITING, THE ARBITRATOR(S) MAY NOT CONSOLIDATE MORE THAN ONE
        INDIVIDUAL PARTY’S CLAIMS WITH ANY OTHER PARTY’S CLAIMS, AND MAY NOT
        OTHERWISE PRESIDE OVER ANY FORM OF A REPRESENTATIVE OR COLLECTIVE
        PROCEEDING.
      </p>
      <p>
        You and We agree to resolve disputes through binding arbitration court
        rather than in a court of general jurisdiction. Arbitration is less
        formal than a lawsuit in court. Arbitration Uses a neutral arbitrator
        instead of a judge or jury, allows for more limited discovery than a
        court does, and is subject to very limited review by courts. Any
        arbitration under these Terms will take place on an individual basis;
        class arbitrations and class actions are not permitted.
      </p>
      <h5>Arbitration Agreement</h5>
      <p>
        We and You agree to arbitrate all disputes and claims between Us before
        a single arbitrator under the American Arbitration Association’s (“AAA”)
        Consumer Arbitration Rules and Mediation Procedures, which are available
        at www.adr.org , except as to how those Consumer Arbitration Rules and
        Mediation Procedures might be modified below.
      </p>
      <p>
        The types of disputes and claims We agree to arbitrate are intended to
        be broadly interpreted. It applies, without limitation, to:
      </p>
      <ul>
        <li>
          Claims arising out of or related to or relating to any aspect of the
          relationship between Us, whether based in contract, tort, statute,
          fraud, misrepresentation, or any other legal theory.
        </li>
        <li>Claims that arose before these or any prior Terms.</li>
        <li>
          Claims that are currently the subject of purported class action
          litigation in which You are not a member of a certified class.
        </li>
        <li>Claims that may arise after termination of these Terms.</li>
      </ul>
      <p>
        For the purposes of this Arbitration Agreement, references to Our, We,
        Ours, or other words defined by these Terms to mean Bump Health, Inc.
        also include Our respective subsidiaries, affiliates, agents, employees,
        predecessors in interest, successors, and assigns, as well as all
        authorized or unauthorized Users or beneficiaries of services or
        products under these Terms or any prior agreements between Us.
      </p>
      <p>
        You agree that, by entering into these Terms, You are waiving the right
        to a trial by jury or to participate in a class action. These Terms
        evidence a transaction or Website use in interstate commerce, and thus
        the Federal Arbitration Act governs the interpretation and enforcement
        of this provision. This arbitration provision will survive termination
        of these Terms.
      </p>
      <p>
        To arbitrate, You must first send, by U.S. certified mail, a written
        Notice of Dispute (“Notice” in this Disputes Resolution section) to the
        other party. A Notice to Us must be addressed to: Notice of Dispute,
        Bump Health, Inc. 7719 North Pioneer Lane Peoria, Illinois 61615 with a
        mandatory copy, also sent U.S. certified mail, to Jonathan LA Phillips,
        Phillips &amp; Bathke, P.C. 300 Northeast Perry, Peoria, Illinois 61603
        the (“Notice address”). The Notice must (a) describe the nature and
        basis of the claim or dispute and (b) set forth the specific relief
        sought (“Demand”). If We and You do not reach an agreement to resolve
        the claim within 30 days after the Notice is received, You or We may
        commence an arbitration proceeding.
      </p>
      <p>
        During the arbitration, the amount of any settlement offer made by Us or
        You will not be disclosed to the arbitrator until after the arbitrator
        determines the amount, if any, to which We or You are entitled.
      </p>
      <p>
        Unless We and You agree otherwise, any arbitration hearings will take
        place in Peoria County, Illinois.
      </p>
      <p>
        If Your claim is for $10,000 or less, You may choose whether the
        arbitration will be conducted solely based on documents submitted to the
        arbitrator, by a telephonic hearing, or by an in-person hearing as
        established by the AAA rules. If You choose to proceed either in-person
        or by telephone, We may choose to respond only by telephone or
        submission. If Your claim exceeds $10,000, the AAA Rules will determine
        whether You have a right to a hearing and the manner of conducting that
        hearing. Regardless of the manner in which the arbitration is conducted,
        the arbitrator shall issue a reasoned written decision sufficient to
        explain the essential findings of fact and conclusions of law on which
        the award is based.
      </p>
      <p>
        The parties agree that any awards or findings of fact or conclusions of
        law made in an arbitration of their dispute or claim are made only for
        the purposes of that arbitration, and may not be used by any other
        person or entity in any later arbitration of any dispute or claim
        involving Us. You and We agree that in any arbitration of a dispute or
        claim, neither party will rely for preclusive effect on any award or
        finding of fact or conclusion of law made in any other arbitration of
        any dispute or claim to which We were a party.
      </p>
      <p>
        As may be provided for by the AAA’s Consumer Arbitration Rules and
        Mediation Procedures, the arbitrator will determine whether fees
        associated with institution of the arbitration shall be recovered by a
        prevailing party. If the arbitrator finds that either the substance of
        Your claim or the relief sought in the Demand is frivolous or brought
        for an improper purpose (as measured by the standards set forth in
        Federal Rule of Civil Procedure 11(b)), then the payment of all such
        fees will be governed by the AAA Rules. In addition, if You initiate an
        arbitration in which You seek more than $75,000 in damages, the payment
        of these fees will be governed by the AAA Rules. An award may be entered
        against a party who fails to appear at a duly noticed hearing.
      </p>
      <p>
        The arbitrator may make rulings and resolve disputes over the payment
        and reimbursement of fees, expenses, and the alternative payment and the
        attorney’s fees at any time during the proceeding and upon request from
        either party made within 14 days of the arbitrator’s ruling on the
        merits.
      </p>
      <p>
        The arbitrator may award injunctive relief only in favor of the
        individual party seeking relief and only as needed to provide relief
        warranted by that party’s individual claim.
      </p>
      <p>
        The arbitrator shall not have the power to commit errors of law or legal
        reasoning, and the parties agree that any injunctive award may be
        vacated or corrected on appeal by either party to a court of competent
        jurisdiction for any such error. Each party will bear its own costs and
        fees on any such appeal. The arbitrator shall not award relief in excess
        of what these Terms provide or award punitive damages or any other form
        of damages not measured by actual damages.
      </p>
      <p>
        All aspects of the arbitration proceeding, and any ruling, decision or
        award by the arbitrator, will be strictly confidential, other than as
        part of an appeal to a court of competent jurisdiction.
      </p>
      <h4>Whistleblowing</h4>
      <p>
        While the dispute resolution process You agree to is set forth above,
        nothing should be construed to limit Your ability bring issues to the
        attention of federal, state, or local governmental authorities and
        agencies. Put another way, the dispute resolution process You agreed to
        does not prevent You from “whistleblowing.” Nor does it bar those
        agencies, if the law allows, from seeking relief against Us on Your
        behalf.
      </p>
      <h4>Disputes Resolution Severability</h4>
      <p>
        If any term of this Section (Disputes Resolution) is to any extent
        illegal, otherwise invalid, or incapable of being enforced, such term
        shall be excluded to the extent of such invalidity or unenforceability;
        all other terms hereof shall remain in full force and effect; and, to
        the extent permitted and possible, the invalid or unenforceable term
        shall be deemed replaced by a term that is valid and enforceable and
        that comes closest to expressing the intention of such invalid or
        unenforceable term. If application of this Disputes Resolution
        Severability provision should materially and adversely affect the
        economic substance of the transactions contemplated hereby, the party
        adversely impacted shall be entitled to compensation for such adverse
        impact, provided the reason for the invalidity or unenforceability of a
        term is not due to serious misconduct by the party seeking such
        compensation.
      </p>
      <h3>For European Union Users</h3>
      <p>
        If You are a European Union consumer, You will benefit from any
        mandatory provisions of the law of the country in which You are
        resident.
      </p>
      <h3>United States Federal Government End Use Provisions</h3>
      <p>
        If You are a U.S. federal government end User, Our Service is a
        &ldquo;Commercial Item&rdquo; as that term is defined at 48 C.F.R. §
        2.101.
      </p>
      <h3>United States Legal Compliance</h3>
      <p>
        You represent and warrant that (i) You are not located in a country that
        is subject to the United States government embargo, or that has been
        designated by the United States government as a &ldquo;terrorist
        supporting&rdquo; country, and (ii) You are not listed on any United
        States government list of prohibited or restricted parties.
      </p>
      <h3>Severability and Waiver</h3>
      <h4>Severability</h4>
      <p>
        If any provision of these Terms is held to be unenforceable or invalid,
        such provision will be changed and interpreted to accomplish the
        objectives of such provision to the greatest extent possible under
        applicable law and the remaining provisions will continue in full force
        and effect.
      </p>
      <h4>Waiver</h4>
      <p>
        Except as provided in these Terms, the failure to exercise a right or to
        require performance of an obligation under these Terms shall not affect
        a party&lsquo;s ability to exercise such right or require such
        performance at any time thereafter nor shall the waiver of a breach
        constitute a waiver of any subsequent breach.
      </p>
      <h3>Changes to These Terms and Conditions</h3>
      <p>
        We reserve the right, at Our sole discretion, to modify or replace these
        Terms at any time. If a revision is material, We will make reasonable
        efforts to provide at least 30 days&lsquo; notice prior to any new terms
        taking effect. What constitutes a material change will be determined at
        Our sole discretion.
      </p>
      <p>
        By continuing to access or use Our Service after those revisions become
        effective, You agree to be bound by the revised terms. If You do not
        agree to the new terms, in whole or in part, please stop using the
        Website and the Service.
      </p>
      <h3>Translation Interpretation</h3>
      <p>
        These Terms and Conditions may have been translated if We have made them
        available to You on Our Service. You agree that the original English
        text shall prevail in the case of a dispute.
      </p>
      <h3>Governing Law</h3>
      <p>
        The laws of the United States and Illinois, excluding its conflicts of
        law rules, shall govern this Terms and Your use of the Service. Your Use
        of the Application may also be subject to other local, state, national,
        or international laws.
      </p>
      <h3>Contact Us</h3>
      <p>
        If You have any questions about these Terms and Conditions, You can
        contact Us:
      </p>
      <p>By email: info@bumpboxes.com</p>
      <h3>Durable Medical Equipment Appendixes</h3>
      <h4>Appendix A – Advanced Directives</h4>
      <p>
        You understand Your right to formulate and to issue Advance Directives
        to be followed should You become incapacitated.
      </p>
      <p>
        What is an Advance Directive? An advance directive is a set of
        directions you give about the medical and mental health care you want if
        you ever lose the ability to make decisions for yourself. There are two
        ways for you to make a formal advance directive. These include: Living
        Wills and Healthcare Powers of Attorney. Forms &amp; additional
        information may be obtained from the Secretary of State website, if you
        are in Illinois, and other sources in other states.
      </p>
      <p>
        Do I have to have an Advance Directive and what happens if I don`t?
        Making an advance directive is your choice. If you become unable to make
        your own decisions, and you have no advance directive, your physician or
        mental health care provider will consult someone close to you about your
        care. Discussing your wishes with your family and friends now will help
        ensure that you get the level of treatment you want when you can no
        longer tell your health providers what you want.
      </p>
      <p>
        What is a Living Will? A Living Will is a legal document that tells
        others that you want to die a natural death if you: become incurably
        sick with an irreversible condition that will result in your death
        within a short period of time; are unconscious and your physician
        determines that it is highly unlikely you will regain consciousness; or
        have advanced dementia or a similar condition which results In a
        substantial cognitive loss and it is highly unlikely the condition can
        be reversed. You can direct your physician not to use certain
        life-prolonging treatments such as a breathing machine (“respirator“ or
        “ventilator“), or to stop giving you food and water through a tube
        (“artificial nutrition or hydration“ through feeding tubes and IVs). The
        document goes into effect only when your physician and one other
        physician determine that you meet one of the conditions specified in the
        Living Will. You can cancel anytime by communicating your intent to
        cancel it in any way.
      </p>
      <p>
        What is a Healthcare Power of Attorney? A Healthcare Power of Attorney
        is a legal document in which you can name a person(s) as your health
        care agent(s) to make medical and mental health decisions for you if you
        become unable to decide for yourself. You can say which treatments you
        would want and not want. You should choose an adult you trust to be your
        health care agent. Discuss your wishes with that person(s) before you
        put them in writing. The document will go into effect when a physician
        states in writing that you are not able to make or to communicate your
        health care choices. You can cancel or change while you are able to make
        and communicate your decisions.
      </p>
      <p>
        How do I make an Advance Directive? There are several rules to protect
        you and ensure your wishes are clear to the physician who may be asked
        to carry them out. An advanced directive must be: (1) written; (2)
        signed by you while you are still able to make and communicate health
        care decisions; (3) witnessed by two qualified adults; and (4)
        notarized. A qualified witness is a competent adult who sees you sign,
        is not a relative, and will not inherit anything from you upon your
        death. The witness cannot be your physician, a licensed employee of your
        physician or any paid employee of a healthcare facility where you live
        or that is treating you.
      </p>
      <p>
        Who should I talk to about an Advance Directive? You should talk to
        those closest to you about an advance directive and your feelings about
        the health care you would like to receive. Your physician or health care
        provider can answer medical questions. A lawyer can answer questions
        about the law. Give copies to your family, your physician or mental
        health providers, your health care agent(s), and any family members or
        close friends who might be asked about your care should you become
        unable to make decisions. Please furnish Bump Health Inc. with a copy of
        your advance directives.
      </p>
      <h4>Appendix B – Infection Control</h4>
      <p>
        It is Our policy to conform to the acceptable standards of infection
        control pertaining to equipment and home health services issued by the
        Centers for Disease Control and the Occupational Safety and Health
        Administration, in order to ensure the safety of clients/patients and
        employees, and also to ensure quality client/patient service.
      </p>
      <p>
        How infections occur and are spread: An infection occurs when germs
        enter the body, increase in number, and cause a reaction of the body.
      </p>
      <p>Three things are necessary for an infection to occur:</p>
      <ul>
        <li>
          Source: Places where infectious agents (germs) live (e.g., sinks,
          surfaces, human skin)
        </li>
        <li>Susceptible Person with a way for germs to enter the body</li>
        <li>Transmission: a way germs are moved to the susceptible person</li>
        <li>
          There are a few general ways that germs travel in healthcare settings:
        </li>
        <li>Through contact (i.e., touching)</li>
        <li>Sprays and splashes (when an infected person coughs or sneezes)</li>
        <li>Inhalation (when germs are aerosolized in tiny particle)</li>
        <li>
          Sharp injuries (i.e., when someone is accidentally stuck with a used
          needle or sharp instrument).
        </li>
      </ul>
      <p>How to prevent infection:</p>
      <ul>
        <li>Wash your hands often</li>
        <li>Get vaccinated</li>
        <li>Get vaccinated and use antibiotics sensibly</li>
        <li>Stay at home if you have signs and symptoms of an infection.</li>
        <li>Cover your mouth and nose</li>
        <li>
          Disinfect the `hot zones` in your residence–the kitchen and bathroom
        </li>
        <li>Don`t share personal items</li>
        <li>
          Make sure health care providers clean their hands or wear gloves
        </li>
        <li>Clean equipment and supplies regularly</li>
        <li>
          Replace equipment on a regular schedule. Contact Bump Health Inc.
          (888-345-1780) when your supplies are to be thrown out.
        </li>
      </ul>
      <p>
        Symptoms of Hepatitis infection: Extreme fatigue, mild fever, headache,
        loss of appetite, nausea, and vomiting. Symptoms of Tuberculosis (TB)
        infection: fatigue, anorexia, productive cough, coughing up blood,
        weight loss, loss of appetite, lethargy, weakness, night sweats, chills,
        flu-like symptoms and fever. Some people with TB may show no symptoms.
        NOTIFY YOUR HEALTHCARE PROVIDER IF YOU FEEL YOU HAVE BECOME INFECTED.
      </p>
      <h4>Appendix C – Patient Bill of Rights &amp; Responsibilities</h4>
      <p>You have the right to:</p>
      <ul>
        <li>
          Receive reasonable coordination and continuity of services from the
          referring agency for home medical equipment services
        </li>
        <li>
          Receive a timely response from Bump Health Inc. when services/care are
          needed or requested
        </li>
        <li>
          Be fully informed in advance about service/care to be provided,
          including the disciplines that furnish care and the frequency of
          visits, as well as any modifications to the Plan of Care
        </li>
        <li>
          Participate in the development and periodic revision of the Plan of
          Service or the Plan of Care
        </li>
        <li>
          Informed consent and refusal of services, care or treatment after the
          consequences of refusing services, care or treatment are fully
          presented
        </li>
        <li>
          Be informed in advance of the charges, including payment for service
          or care expected from third-parties and any charges for which the
          client/patient will be responsible
        </li>
        <li>
          Have one`s property and person treated with respect, consideration,
          and recognition of client/patient dignity and individuality
        </li>
        <li>
          Be able to identify visiting staff members through proper
          identification
        </li>
        <li>
          Voice grievances/complaints regarding treatment of care or lack of
          respect of property, or recommend changes in policy, staff or
          service/care without restraint, interference, coercion, discrimination
          or reprisal
        </li>
        <li>
          Have grievances/complaints regarding treatment or care that is (or
          fails to be) furnished, or lack of respect of property investigated
        </li>
        <li>
          Choose a health care provider and have access to information regarding
          provider`s work history and training
        </li>
        <li>
          Confidentiality and privacy of all information contained in the
          client/patient record and of Protected Health Information
        </li>
        <li>
          Receive appropriate service/care without discrimination in accordance
          with physician orders
        </li>
        <li>
          Be informed of any financial benefits when referred to an organization
        </li>
        <li>
          Be informed in advance of care/service being provided and their
          financial responsibility
        </li>
        <li>
          Be fully informed of one`s responsibilities and Bump Health Inc.`s
          policies regarding patient responsibilities
        </li>
        <li>
          Be informed of client/patient rights under state law to formulate
          advance care directives
        </li>
        <li>
          Be informed of anticipated outcomes of service or care and of any
          barriers in outcome achievement
        </li>
        <li>Be informed of Bump Health Inc.`s on-call service.</li>
        <li>
          Be informed of Bump Health Inc.`s patient satisfaction survey process.
        </li>
        <li>Be informed of supervisory accessibility and availability.</li>
        <li>
          Fair treatment, regardless of race, ethnicity, creed, religious
          belief, sexual orientation, gender, age, health status, or source of
          payment for care.
        </li>
        <li>
          Be advised on Bump Health Inc.`s policies and procedures regarding the
          disclosure of clinical records, clinical guidelines, and management of
          care
        </li>
        <li>Be advised of Bump Health Inc.`s procedures for discharge.</li>
        <li>Report fraud, waste, or abuse</li>
        <li>
          Be notified within 10 days if Bump Health Inc.`s license is revoked,
          suspended, cancelled, annulled, withdrawn, recalled, or amended.
        </li>
        <li>
          Know of their rights and responsibilities in the treatment process
          (and the laws that relate to them), and to make recommendations
          regarding the organization`s rights and responsibilities policy.
        </li>
        <li>
          Be informed about advocacy and community groups and prevention
          services.
        </li>
        <li>Access care easily and in a timely fashion.</li>
        <li>
          Candid discussion about all their treatment choices, regardless of
          cost or coverage by their benefit plan.
        </li>
        <li>The delivery of services in a culturally competent manner.</li>
        <li>
          Receive information about the scope of services that the organization
          will provide and specific limitations on those services.
        </li>
        <li>
          Be free from mistreatment, neglect, or verbal, mental, sexual, and
          physical abuse, including injuries of an unknown source, and
          misappropriation of client/patient property.
        </li>
      </ul>
      <p>Client/Patient has the responsibility to:</p>
      <ul>
        <li>
          Client agrees that rental equipment will be used with reasonable care,
          not altered or modified, and returned in good condition (normal wear
          and tear excepted).
        </li>
        <li>
          Client agrees to promptly report to Bump Health Inc. any malfunctions
          or defects in rental equipment so that repair/ replacement can be
          arranged.
        </li>
        <li>
          Client agrees to provide Bump Health Inc. access to all rental
          equipment for repair/replacement, maintenance, and/or pick-up of the
          equipment.
        </li>
        <li>
          Client agrees to use the equipment for the purposes so indicated and
          in compliance with the physician`s prescription.
        </li>
        <li>
          Client agrees to keep the equipment in their possession and at the
          address, to which it was delivered unless otherwise authorized by Bump
          Health Inc.
        </li>
        <li>
          Client agrees to notify Bump Health Inc. of any hospitalization,
          change in customer insurance, address, telephone number, physician, or
          when the medical need for the rental equipment no longer exists.
        </li>
        <li>
          Client agrees to request payment of authorized Medicare, Medicaid, or
          other private insurance benefits are paid directly to Bump Health Inc.
          for any services furnished by Bump Health Inc.
        </li>
        <li>
          Client agrees to accept all financial responsibility for home medical
          equipment furnished by Bump Health Inc.
        </li>
        <li>
          Client agrees to pay for the replacement cost of any equipment
          damaged, destroyed, or lost due to misuse, abuse or neglect.
        </li>
        <li>
          Client agrees not to modify the rental equipment without the prior
          consent of Bump Health Inc.
        </li>
        <li>
          Client agrees that any authorized modification shall belong to the
          titleholder of the equipment unless equipment is purchased and paid
          for in full.
        </li>
        <li>
          Client agrees that title to the rental equipment and all parts shall
          remain with Bump Health Inc. at all times unless equipment is
          purchased and paid for in full.
        </li>
        <li>
          Client agrees that Bump Health Inc. shall not insure or be responsible
          to the client for any personal injury or property damage related to
          any equipment; including that caused by use or improper functioning of
          the equipment; the act or omission of any other third-party, or by any
          criminal act or activity, war, riot, insurrection, fire or act of God
        </li>
        <li>
          Client understands that Bump Health Inc. retains the right to refuse
          delivery of service to any client at any time.
        </li>
        <li>
          Client agrees that any attorneys’ fees resulting from a disagreement
          between the parties shall be borne by the unsuccessful party in any
          action taken.
        </li>
        <li>
          Patients/Clients have the responsibility to give providers the
          information they need, in order to provide the best possible care and
          to ask questions about their care.
        </li>
        <li>
          Clients have the responsibility to treat those giving them care with
          dignity and respect and not to take actions that could harm others.
        </li>
        <li>
          Patients/Clients have the responsibility to understand and help
          develop and follow the agreed-upon treatment plans for their care,
          including the agreed-upon medication plan and to let the provider know
          when the treatment plan no longer works for them.
        </li>
        <li>
          Patients/Clients have the responsibility to keep their appointments.
          Patients should call their providers as soon as possible if they need
          to cancel visits.
        </li>
        <li>
          Patients/Clients have the responsibility to let their provider know
          about any changes to their contact information (name, address, phone,
          etc.) and insurance coverage.
        </li>
        <li>
          Patients/Clients have the responsibility to tell their provider about
          medication changes, including medications given to them by others.
        </li>
        <li>
          Patients/Clients have the responsibility to let their provider know
          about problems with paying fees.
        </li>
      </ul>
    </Col>
  </Row>
);

export default TermsText;
